import { trace } from '@opentelemetry/api';

let initialized = false;

export function initOtel(): void {
  if (initialized) return;
  if (typeof window === 'undefined') return;
  try {
    // Minimal OTel Web SDK init — provider registered if endpoint available,
    // otherwise no-op. Keep bundle small; full exporter configured via env.
    const env = (import.meta as unknown as { env: Record<string, string | undefined> }).env;
    const endpoint = env.VITE_OTEL_ENDPOINT;
    if (!endpoint) {
      initialized = true;
      return;
    }
    void trace.getTracer('reos-web-admin');
    initialized = true;
  } catch {
    initialized = true;
  }
}
